import { INotificationState } from './Notification.types'

export const NotificationState: INotificationState = {
  notifications: []
}
